import { apiGateAI } from '../services/api_gate'

export async function getTextAI(prompt, max_tokens = 750, temperature = 0.7,) {
  try {
    const dados = { prompt, max_tokens, temperature }
    const response = await apiGateAI.post('/gateIA', dados)
    return response.data
  } catch (error) {
    console.error('API Gate AI Error:', error)
    return { success: false, error: error.message }
  }
}

